import React from 'react';
import { connect } from 'react-redux';
import { isNil, has } from '../../../services/helper';

function CaravanOutsideImage(props) {

    const { configuration } = props;
    const { caravan, configurations } = configuration;
    const caravanName = has(caravan, 'name') ? caravan.name : '';
    const caravanImage = has(caravan, 'image') ? caravan.image : null;
    const caravanImageUri = has(caravanImage, 'href') ? `/${caravanImage.href}` : null;
    const paintworkImage = has(configurations.paintwork, 'image') ? `/${configurations.paintwork.image}` : null; // eslint-disable-line max-len
    const headerImage = !isNil(paintworkImage) ? paintworkImage : caravanImageUri;
    return (
        isNil(headerImage) ? null : <img src={headerImage} alt={caravanName} />
    );

}

const mapStateToProps = state => ({
    configuration: state.configuration,
});

export default connect(mapStateToProps, null)(CaravanOutsideImage);
